import { Rv, Counter, Kicker, Source, HBar, TiltCard } from "../ui";
import { Bars3D } from "../Bars3D";

export const S5 = () => (
  <div className="slide split globe-right" data-testid="slide-5">
    <div className="col">
      <Kicker n="04">Il gasdotto</Kicker>
      <Rv d={0.3}><h2 className="title">Algeria e <em>TransMed</em>.</h2></Rv>
      <Rv d={0.6}><p className="body">Nel 2022 gli accordi ENI–Sonatrach aumentano progressivamente i volumi che attraversano il Mediterraneo lungo il TransMed, dal Sahara alla Sicilia.</p></Rv>
      <Rv d={1.0} className="hbars glass">
        <div className="tag">Primo fornitore di gas importato in Italia</div>
        <HBar label="2023" value={25.5} max={28} d={1.2} color="linear-gradient(90deg,#ff6a1a,#ffb347)" testid="s5-bar-2023" />
        <HBar label="2024" value={23.3} max={28} d={1.5} color="linear-gradient(90deg,#ff6a1a,#ffcf8a)" testid="s5-bar-2024" />
      </Rv>
    </div>
    <Source>ARERA, Relazioni Annuali 2024 e 2025 · ENI S.p.A., comunicati ufficiali (Algeria)</Source>
  </div>
);

const SKY = [
  { label: "Algeria", value: 23.3, color: "#ffb347" },
  { label: "Azerbaigian", value: 10.3, color: "#ff8a3a" },
  { label: "Qatar", value: 6.9, color: "#6cc5ff" },
  { label: "Russia", value: 5.7, color: "#c8401a" },
  { label: "USA", value: 5.2, color: "#8fd3ff" },
];

export const S6 = () => (
  <div className="slide split wide-left" data-testid="slide-6">
    <div className="col chart-col">
      <Kicker n="05">Importazioni 2024 per paese</Kicker>
      <Rv d={0.3}><h2 className="title">Non sostituzione, ma <em>moltiplicazione</em>.</h2></Rv>
      <Rv d={0.5} className="sky-wrap">
        <Bars3D data={SKY} max={24} height={3.4} spacing={1.55} width={0.82} def={[0.38, -0.5]} delay={700} stagger={260} testid="s6-skyline" cam={[0, 2.2, 11]} />
        <div className="drag-hint">mld m³ · trascina per ruotare lo skyline</div>
      </Rv>
    </div>
    <div className="col right-stat">
      <Rv d={1.6}><div className="giant amber"><Counter to={95.2} delay={1700} dur={2200} testid="s6-dependency" /><span className="unit">%</span></div></Rv>
      <Rv d={1.9}><p className="body">del gas disponibile in Italia nel 2024 proveniva <b>dall'estero</b>. La dipendenza non scompare: cambia forma.</p></Rv>
    </div>
    <Source>ARERA, Relazioni Annuali 2024 e 2025 · dati MASE</Source>
  </div>
);

export const S7 = () => (
  <div className="slide split globe-right" data-testid="slide-7">
    <div className="col">
      <Kicker n="06">Gas naturale liquefatto</Kicker>
      <Rv d={0.3}><h2 className="title">Il GNL rende il gas <em className="ice">flessibile</em>.</h2></Rv>
      <div className="stat-grid">
        <Rv d={0.8} className="stat glass">
          <div className="stat-num ice">−162<small>°C</small></div>
          <div className="cap">il gas diventa liquido e viaggia via nave</div>
        </Rv>
        <Rv d={1.0} className="stat glass">
          <div className="stat-num ice"><Counter from={16.5} to={14.7} delay={1200} dur={2000} testid="s7-lng" /></div>
          <div className="cap">mld m³ di GNL · da 16,5 (2023) a 14,7 (2024)</div>
        </Rv>
        <Rv d={1.2} className="stat glass">
          <div className="stat-num ice"><Counter to={95} dec={0} delay={1300} />%</div>
          <div className="cap">del GNL arriva da tre soli paesi</div>
        </Rv>
        <Rv d={1.4} className="stat glass">
          <div className="stat-num ice">≈¼</div>
          <div className="cap">delle importazioni totali di gas</div>
        </Rv>
      </div>
    </div>
    <Source>ARERA, Relazioni Annuali 2024 e 2025 · dati MASE</Source>
  </div>
);

const Depth = () => (
  <svg viewBox="0 0 300 170" className="mini">
    <rect x="0" y="22" width="300" height="148" className="sea" />
    <path d="M110 22 L190 22 L182 10 L118 10 Z" className="flng" />
    <path d="M150 22 L150 158" className="riser" />
    <path d="M0 160 Q80 150 150 158 T300 156" className="seabed" />
    {[["0 m", 26], ["1.000 m", 92], ["≈2.000 m", 156]].map(([t, y]) => <text key={t} x="6" y={y} className="mini-t">{t}</text>)}
  </svg>
);

const Convert = () => (
  <svg viewBox="0 0 300 170" className="mini">
    <rect x="40" y="40" width="70" height="110" className="blk ice" />
    <rect x="190" y="10" width="70" height="140" className="blk amber" />
    <path d="M122 95 L178 95 M168 85 L178 95 L168 105" className="arrow" />
    <text x="75" y="30" className="mini-t" textAnchor="middle">≈3 Mt GNL</text>
    <text x="225" y="166" className="mini-t" textAnchor="middle">≈4,5 mld m³ gas</text>
  </svg>
);

const Poles = () => (
  <svg viewBox="0 0 300 170" className="mini">
    <path d="M60 130 L150 40 L240 120 Z" className="tri" />
    {[[60, 130, "Mozambico"], [240, 120, "Congo"]].map(([x, y, t]) => (
      <g key={t}><circle cx={x} cy={y} r="7" className="pole" /><text x={x} y={y + 26} className="mini-t" textAnchor="middle">{t}</text></g>
    ))}
    <circle cx="150" cy="40" r="14" className="pole hot" /><circle cx="150" cy="40" r="14" className="pole-pulse" />
    <text x="150" y="14" className="mini-t" textAnchor="middle">Qatar</text>
  </svg>
);

export const S8 = () => (
  <div className="slide" data-testid="slide-8">
    <Kicker n="07">Upstream e GNL</Kicker>
    <Rv d={0.3}><h2 className="title">Tre progetti, <em>tre geografie</em>.</h2></Rv>
    <div className="cards3d">
      <TiltCard d={0.6} base="rotateY(14deg) translateZ(-40px)" testid="card-coral">
        <div className="card-k">Mozambico</div><h3>Coral Sul FLNG</h3><Depth />
        <div className="card-num amber">≈3,4 <small>Mt/anno</small></div>
        <p>Liquefazione galleggiante in acque profonde circa 2.000 m.</p>
      </TiltCard>
      <TiltCard d={0.8} base="translateZ(30px)" testid="card-congo">
        <div className="card-k">Congo</div><h3>Congo LNG</h3><Convert />
        <div className="card-num amber">≈3 <small>Mt/anno</small></div>
        <p>Seconda fase: circa 4,5 mld m³ di gas equivalente.</p>
      </TiltCard>
      <TiltCard d={1.0} base="rotateY(-14deg) translateZ(-40px)" testid="card-qatar">
        <div className="card-k">Qatar</div><h3>Il terzo polo</h3><Poles />
        <div className="card-num ice">Polo mondiale</div>
        <p>Accesso a uno dei poli mondiali del GNL.</p>
      </TiltCard>
    </div>
    <Source>ENI S.p.A., Relazione Finanziaria Annuale 2024 e comunicati ufficiali</Source>
  </div>
);
